import { FieldOption } from '../../../../Constants/FieldOption';

export class IdentityApiModel {
	Id: number;
	Nationality: string;
	NationalIdentityNumber: string;
	Phone: string;
	FirstName: string;
	LastName: string;
	Email: string;
	NationalIdentityNumberRequirement: FieldOption;
	PhoneRequirement: FieldOption;
	EmailRequirement: FieldOption;

	// Not in backend YET VC-2430
	UserType: 'Client' | 'Outsider' | 'Resource';
	// LicenceHolderId: number;
	// Id: number;

	public legacyDocumentSignin = false;

	// Frontend property
	get CommonName() {
		return `${this.FirstName} ${this.LastName}`;
	}
}
